webpackJsonp([28],{

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_main_store_js__ = __webpack_require__(1141);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67352374_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_store_vue__ = __webpack_require__(1334);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_main_store_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67352374_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_store_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main_item',
  methods: {
    goToPage: function goToPage(path) {
      this.$store.state.historyPage = this.$route.path;
      this.$router.push(path);
    },
    doing: function doing() {
      alert('รอดำเนินการ');
    }
  },
  mounted: function mounted() {
    this.$store.state.historyPage = '';
    this.checkUser();
  }
});

/***/ }),

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height' : _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body text-center"},[_c('h1',{staticStyle:{"font-weight":"bold"}},[_vm._v("ระบบบริหารสินค้าคงคลัง")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-start flex-wrap"},[_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('itemlist')}}},[_c('i',{staticClass:"fas fa-store",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("จัดการสินค้า")])]),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('adjust_item')}}},[_c('i',{staticClass:"fas fa-code-branch",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("ปรับปรุงสินค้า")])]),_vm._v(" "),_c('div',{staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goToPage('receivelist')}}},[_c('i',{staticClass:"fas fa-file-signature",staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-1"},[_vm._v("บันทึกรับสินค้าเข้า")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/28.73a98e2d321cbcfad75d.js